module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_306238.49505a2d.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/ift/InternetSatF/FormatoSimplificado_306238.pdf
// module id = 824
// module chunks = 0